/** Load-level styling for block-week session cards (periodization timesheet). */
export const LOAD_LEVEL_STYLES = {
  rest: {
    card: 'border-slate-500/35 bg-slate-500/8',
    dot: 'bg-slate-400',
  },
  recovery: {
    card: 'border-emerald-500/40 bg-emerald-500/10',
    dot: 'bg-emerald-500',
  },
  easy: {
    card: 'border-sky-500/40 bg-sky-500/10',
    dot: 'bg-sky-500',
  },
  moderate: {
    card: 'border-amber-500/45 bg-amber-500/10',
    dot: 'bg-amber-500',
  },
  quality: {
    card: 'border-rose-500/50 bg-rose-500/12',
    dot: 'bg-rose-500',
  },
  long: {
    card: 'border-violet-500/45 bg-violet-500/12',
    dot: 'bg-violet-500',
  },
};

export function loadLevelStyle(loadLevel) {
  return LOAD_LEVEL_STYLES[loadLevel] || LOAD_LEVEL_STYLES.easy;
}

export function weekDayKeys(weekStartYmd) {
  if (!weekStartYmd) return [];
  const [y, m, d] = String(weekStartYmd).slice(0, 10).split('-').map(Number);
  const days = [];
  for (let i = 0; i < 7; i += 1) {
    const dt = new Date(y, m - 1, d + i);
    const yy = dt.getFullYear();
    const mm = String(dt.getMonth() + 1).padStart(2, '0');
    const dd = String(dt.getDate()).padStart(2, '0');
    days.push(`${yy}-${mm}-${dd}`);
  }
  return days;
}
